export default {
  message: {
    type: 'results',
    tournamentId: 12,
    raceId: 74,
    delay: 20,
    winner: {
      id: 10,
      name: 'Riki Kaikkonen',
      odds: 1.75,
      time: '12.23',
      stage: 'quarterFinals',
    },
    knockout: {
      eighthFinals: [
        {
          competitor1: {
            id: 13,
            name: 'Liki Nauda',
            won: false,
            odds: 2.1,
          },
          competitor2: {
            id: 34,
            name: 'Riki Kaikkonen',
            won: true,
            odds: 2.1,
          },
        },
        {
          competitor1: {
            id: 10,
            name: 'Roberk Tubica',
            won: false,
            odds: 2.1,
          },
          competitor2: {
            id: 7,
            name: 'Kika Mahkinen',
            won: true,
            odds: 2.1,
          },
        },
        {
          competitor1: {
            id: 13,
            name: 'Liki Nauda',
            won: false,
            odds: 2.1,
          },
          competitor2: {
            id: 34,
            name: 'Riki Kaikkonen',
            won: true,
            odds: 2.1,
          },
        },
        {
          competitor1: {
            id: 13,
            name: 'Liki Nauda',
            won: false,
            odds: 2.1,
          },
          competitor2: {
            id: 34,
            name: 'Riki Kaikkonen',
            won: true,
            odds: 2.1,
          },
        },
        {
          competitor1: {
            id: 13,
            name: 'Liki Nauda',
            won: true,
            odds: 2.1,
          },
          competitor2: {
            id: 34,
            name: 'Riki Kaikkonen',
            won: false,
            odds: 2.1,
          },
        },
        {
          competitor1: {
            id: 13,
            name: 'Liki Nauda',
            won: false,
            odds: 2.1,
          },
          competitor2: {
            id: 34,
            name: 'Riki Kaikkonen',
            won: false,
            odds: 2.1,
          },
        },
        {
          competitor1: {
            id: 10,
            name: 'Roberk Tubica',
            won: false,
            odds: 2.1,
          },
          competitor2: {
            id: 7,
            name: 'Kika Mahkinen',
            won: false,
            odds: 2.1,
          },
        },
        {
          competitor1: {
            id: 13,
            name: 'Liki Nauda',
            won: false,
            odds: 2.1,
          },
          competitor2: {
            id: 34,
            name: 'Riki Kaikkonen',
            won: false,
            odds: 2.1,
          },
        },
      ],
      quarterFinals: [
        {
          competitor1: {
            id: 34,
            name: 'Riki Kaikkonen',
            won: false,
            odds: 2.1,
          },
          competitor2: {
            id: 7,
            name: 'Kika Mahkinen',
            won: false,
            odds: 2.1,
          },
        },
        {
          competitor1: {
            id: 10,
            name: 'Roberk Tubica',
            won: false,
            odds: 2.1,
          },
          competitor2: {
            id: 7,
            name: 'Kika Mahkinen',
            won: true,
            odds: 2.1,
          },
        },
        {
          competitor1: {
            id: 13,
            name: 'Liki Nauda',
            won: true,
            odds: null,
          },
          2: null,
        },
        {
          1: null,
          2: null,
        },
      ],
      semiFinals: [
        {
          1: null,
          competitor2: {
            id: 7,
            name: 'Kika Mahkinen',
            won: false,
            odds: null,
          },
        },
        null,
      ],
    },
    previousResults: [
      {
        tournamentId: 123,
        knockout: {
          eighthFinals: [
            {
              competitor1: {
                id: 13,
                name: 'Liki Nauda',
                won: false,
                odds: 2.1,
              },
              competitor2: {
                id: 34,
                name: 'Riki Kaikkonen',
                won: true,
                odds: 2.1,
              },
            },
            {
              competitor1: {
                id: 10,
                name: 'Roberk Tubica',
                won: false,
                odds: 2.1,
              },
              competitor2: {
                id: 7,
                name: 'Kika Mahkinen',
                won: true,
                odds: 2.1,
              },
            },
            {
              competitor1: {
                id: 13,
                name: 'Liki Nauda',
                won: false,
                odds: 2.1,
              },
              competitor2: {
                id: 34,
                name: 'Riki Kaikkonen',
                won: true,
                odds: 2.1,
              },
            },
            {
              competitor1: {
                id: 13,
                name: 'Liki Nauda',
                won: false,
                odds: 2.1,
              },
              competitor2: {
                id: 34,
                name: 'Riki Kaikkonen',
                won: true,
                odds: 2.1,
              },
            },
            {
              competitor1: {
                id: 13,
                name: 'Liki Nauda',
                won: true,
                odds: 2.1,
              },
              competitor2: {
                id: 34,
                name: 'Riki Kaikkonen',
                won: false,
                odds: 2.1,
              },
            },
            {
              competitor1: {
                id: 13,
                name: 'Liki Nauda',
                won: true,
                odds: 2.1,
              },
              competitor2: {
                id: 34,
                name: 'Riki Kaikkonen',
                won: false,
                odds: 2.1,
              },
            },
            {
              competitor1: {
                id: 10,
                name: 'Roberk Tubica',
                won: true,
                odds: 2.1,
              },
              competitor2: {
                id: 7,
                name: 'Kika Mahkinen',
                won: false,
                odds: 2.1,
              },
            },
            {
              competitor1: {
                id: 13,
                name: 'Liki Nauda',
                won: false,
                odds: 2.1,
              },
              competitor2: {
                id: 34,
                name: 'Riki Kaikkonen',
                won: true,
                odds: 2.1,
              },
            },
          ],
          quarterFinals: [
            {
              competitor1: {
                id: 34,
                name: 'Riki Kaikkonen',
                won: false,
                odds: 2.1,
              },
              competitor2: {
                id: 7,
                name: 'Kika Mahkinen',
                won: false,
                odds: 2.1,
              },
            },
            {
              competitor1: {
                id: 10,
                name: 'Roberk Tubica',
                won: false,
                odds: 2.1,
              },
              competitor2: {
                id: 7,
                name: 'Kika Mahkinen',
                won: true,
                odds: 2.1,
              },
            },
            {
              competitor1: {
                id: 13,
                name: 'Liki Nauda',
                won: true,
                odds: null,
              },
              competitor2: null,
            },
            {
              competitor1: null,
              competitor2: null,
            },
          ],
          semiFinals: [
            {
              competitor1: {
                id: 13,
                name: 'Liki Nauda',
                won: true,
                odds: 2.1,
              },
              competitor2: {
                id: 7,
                name: 'Kika Mahkinen',
                won: false,
                odds: 2.1,
              },
            },
            {
              competitor1: {
                id: 13,
                name: 'Liki Nauda',
                won: true,
                odds: 2.1,
              },
              competitor2: {
                id: 7,
                name: 'Kika Mahkinen',
                won: false,
                odds: 2.1,
              },
            },
          ],
          finals: [
            {
              competitor1: {
                id: 13,
                name: 'Liki Nauda',
                won: true,
                odds: 2.1,
              },
              competitor2: {
                id: 7,
                name: 'Kika Mahkinen',
                won: false,
                odds: 2.1,
              },
            },
          ],
        },
      },
    ],
    // },
  },
  state: {
    tournamentId: 12,
    raceId: 74,
    type: 'results',
    delay: 20,
    time: 1563517078015,
    winner: {
      id: 10,
      name: 'Riki Kaikkonen',
      time: '12.23',
      odds: 1.75,
      stage: 'quarterFinals',
    },
    knockout: {
      eighthFinals: [
        {
          competitor1: {
            id: 13,
            name: 'Liki Nauda',
            won: false,
            odds: 2.1,
          },
          competitor2: {
            id: 34,
            name: 'Riki Kaikkonen',
            won: true,
            odds: 2.1,
          },
        },
        {
          competitor1: {
            id: 10,
            name: 'Roberk Tubica',
            won: false,
            odds: 2.1,
          },
          competitor2: {
            id: 7,
            name: 'Kika Mahkinen',
            won: true,
            odds: 2.1,
          },
        },
        {
          competitor1: {
            id: 13,
            name: 'Liki Nauda',
            won: false,
            odds: 2.1,
          },
          competitor2: {
            id: 34,
            name: 'Riki Kaikkonen',
            won: true,
            odds: 2.1,
          },
        },
        {
          competitor1: {
            id: 13,
            name: 'Liki Nauda',
            won: false,
            odds: 2.1,
          },
          competitor2: {
            id: 34,
            name: 'Riki Kaikkonen',
            won: true,
            odds: 2.1,
          },
        },
        {
          competitor1: {
            id: 13,
            name: 'Liki Nauda',
            won: true,
            odds: 2.1,
          },
          competitor2: {
            id: 34,
            name: 'Riki Kaikkonen',
            won: false,
            odds: 2.1,
          },
        },
        {
          competitor1: {
            id: 13,
            name: 'Liki Nauda',
            won: false,
            odds: 2.1,
          },
          competitor2: {
            id: 34,
            name: 'Riki Kaikkonen',
            won: false,
            odds: 2.1,
          },
        },
        {
          competitor1: {
            id: 10,
            name: 'Roberk Tubica',
            won: false,
            odds: 2.1,
          },
          competitor2: {
            id: 7,
            name: 'Kika Mahkinen',
            won: false,
            odds: 2.1,
          },
        },
        {
          competitor1: {
            id: 13,
            name: 'Liki Nauda',
            won: false,
            odds: 2.1,
          },
          competitor2: {
            id: 34,
            name: 'Riki Kaikkonen',
            won: false,
            odds: 2.1,
          },
        },
      ],
      quarterFinals: [
        {
          competitor1: {
            id: 34,
            name: 'Riki Kaikkonen',
            won: false,
            odds: 2.1,
          },
          competitor2: {
            id: 7,
            name: 'Kika Mahkinen',
            won: false,
            odds: 2.1,
          },
        },
        {
          competitor1: {
            id: 10,
            name: 'Roberk Tubica',
            won: false,
            odds: 2.1,
          },
          competitor2: {
            id: 7,
            name: 'Kika Mahkinen',
            won: true,
            odds: 2.1,
          },
        },
        {
          competitor1: {
            id: 13,
            name: 'Liki Nauda',
            won: false,
            odds: null,
          },
          2: null,
        },
        {
          1: null,
          2: null,
        },
      ],
      semiFinals: [
        {
          1: null,
          competitor2: {
            id: 7,
            name: 'Kika Mahkinen',
            won: false,
            odds: null,
          },
        },
        null,
      ],
      // finals: [
      //   {
      //     competitor1: {
      //       id: 13,
      //       name: 'Liki Nauda',
      //       won: true,
      //       odds: 2.1,
      //     },
      //     competitor2: {
      //       id: 7,
      //       name: 'Kika Mahkinen',
      //       won: false,
      //       odds: 2.1,
      //     },
      //   },
      // ],
    },
    previousResults: [
      {
        tournamentId: 123,
        knockout: {
          eighthFinals: [
            {
              competitor1: {
                id: 13,
                name: 'Liki Nauda',
                won: false,
                odds: 2.1,
              },
              competitor2: {
                id: 34,
                name: 'Riki Kaikkonen',
                won: true,
                odds: 2.1,
              },
            },
            {
              competitor1: {
                id: 10,
                name: 'Roberk Tubica',
                won: false,
                odds: 2.1,
              },
              competitor2: {
                id: 7,
                name: 'Kika Mahkinen',
                won: true,
                odds: 2.1,
              },
            },
            {
              competitor1: {
                id: 13,
                name: 'Liki Nauda',
                won: false,
                odds: 2.1,
              },
              competitor2: {
                id: 34,
                name: 'Riki Kaikkonen',
                won: true,
                odds: 2.1,
              },
            },
            {
              competitor1: {
                id: 13,
                name: 'Liki Nauda',
                won: false,
                odds: 2.1,
              },
              competitor2: {
                id: 34,
                name: 'Riki Kaikkonen',
                won: true,
                odds: 2.1,
              },
            },
            {
              competitor1: {
                id: 13,
                name: 'Liki Nauda',
                won: true,
                odds: 2.1,
              },
              competitor2: {
                id: 34,
                name: 'Riki Kaikkonen',
                won: false,
                odds: 2.1,
              },
            },
            {
              competitor1: {
                id: 13,
                name: 'Liki Nauda',
                won: true,
                odds: 2.1,
              },
              competitor2: {
                id: 34,
                name: 'Riki Kaikkonen',
                won: false,
                odds: 2.1,
              },
            },
            {
              competitor1: {
                id: 10,
                name: 'Roberk Tubica',
                won: true,
                odds: 2.1,
              },
              competitor2: {
                id: 7,
                name: 'Kika Mahkinen',
                won: false,
                odds: 2.1,
              },
            },
            {
              competitor1: {
                id: 13,
                name: 'Liki Nauda',
                won: false,
                odds: 2.1,
              },
              competitor2: {
                id: 34,
                name: 'Riki Kaikkonen',
                won: true,
                odds: 2.1,
              },
            },
          ],
          quarterFinals: [
            {
              competitor1: {
                id: 34,
                name: 'Riki Kaikkonen',
                won: false,
                odds: 2.1,
              },
              competitor2: {
                id: 7,
                name: 'Kika Mahkinen',
                won: false,
                odds: 2.1,
              },
            },
            {
              competitor1: {
                id: 10,
                name: 'Roberk Tubica',
                won: false,
                odds: 2.1,
              },
              competitor2: {
                id: 7,
                name: 'Kika Mahkinen',
                won: true,
                odds: 2.1,
              },
            },
            {
              competitor1: {
                id: 13,
                name: 'Liki Nauda',
                won: true,
                odds: null,
              },
              competitor2: null,
            },
            {
              competitor1: null,
              competitor2: null,
            },
          ],
          semiFinals: [
            {
              competitor1: {
                id: 13,
                name: 'Liki Nauda',
                won: true,
                odds: 2.1,
              },
              competitor2: {
                id: 7,
                name: 'Kika Mahkinen',
                won: false,
                odds: 2.1,
              },
            },
            {
              competitor1: {
                id: 13,
                name: 'Liki Nauda',
                won: true,
                odds: 2.1,
              },
              competitor2: {
                id: 7,
                name: 'Kika Mahkinen',
                won: false,
                odds: 2.1,
              },
            },
          ],
          finals: [
            {
              competitor1: {
                id: 13,
                name: 'Liki Nauda',
                won: true,
                odds: 2.1,
              },
              competitor2: {
                id: 7,
                name: 'Kika Mahkinen',
                won: false,
                odds: 2.1,
              },
            },
          ],
        },
      },
    ],
  },
};
